import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a4e3e35&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=1a4e3e35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e3e35",
  null
  
)

export default component.exports